import { Component, Inject } from '@angular/core';
import { IonRouterOutlet, Platform, NavController } from '@ionic/angular';
import { Location } from '@angular/common';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from 'src/models/contants.models';
import { APP_CONFIG, AppConfig } from './app.config';

import { AuthService } from 'src/services/auth.service';
import { MloggerProvider, Mlogger } from 'src/services/mlogger.service';
import { ProfileService } from 'src/services/profile.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  profileData: any;
  isLoggedIn: boolean = false;
  constructor(@Inject(APP_CONFIG) public config: AppConfig, private platform: Platform, private _location: Location, private navCtrl: NavController, private statusBar: StatusBar, private splashScreen: SplashScreen, private _mlogger: MloggerProvider, private _authService: AuthService, private _profileService: ProfileService, private translate: TranslateService) {
    this.platform.backButton.subscribeWithPriority(10, (processNextHandler) => {
      if (this._location.isCurrentPathEqualTo('/tab/my-dashboard')) {
        // Show Exit Alert!
        //this.showExitConfirm();
        navigator['app'].exitApp();//comment this when this.showExitConfirm(); is uncommented
        processNextHandler();
      } else {
        // Navigate to back page
        this._location.back();
      }
    });

    if (localStorage.getItem('userId') === null) {
      this.navCtrl.navigateRoot(['./landing-screen']);
    } else {
      if (location.pathname !== '/payment-response') {
        this.navCtrl.navigateRoot(['./tabs/home']);
      }
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleLightContent();
      this.splashScreen.hide();
      let defaultLang = window.localStorage.getItem(Constants.KEY_DEFAULT_LANGUAGE);
      this.globalize(defaultLang);
      // Trigger the push setup 
      //this.fcmService.initPush();
    });
    this._mlogger.log_init(environment.loggingTool, 'mlogger', null, Mlogger.severity.debug, null, null, '+5:30', {});
    this._authService.userLogin.subscribe(
      data => {
        this.isLoggedIn = (data.state === 'login') ? true : false;
        this._authService.log({ subscibeLogin: data });
      }
    );
    this._profileService.userProfile.subscribe(
      data => {
        this._profileService.log({ subscibeProfile: data });
        this.profileData = data.data;
      }
    );
  }
  globalize(languagePriority) {
    this.translate.setDefaultLang("en");
    let defaultLangCode = this.config.availableLanguages[0].code;
    this.translate.use(languagePriority && languagePriority.length ? languagePriority : defaultLangCode);
    //this.setDirectionAccordingly(languagePriority && languagePriority.length ? languagePriority : defaultLangCode);
  }

}
